
import { PermissionTypeEnum, TenantUserModel, LocationModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue, Watch } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import { locationsStore } from '@/libs/locations/+state/store';

@Component({})
export default class TenantUserSelect extends Vue {
    @VModel() innerValue!: string;
    @Prop() inputValue!: string | null | undefined;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: false }) createParty!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) noMarginTop!: boolean;
    @Prop({ default: true }) chips!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: false }) showDepartment!: boolean;
    @Prop({ default: null }) categoryId!: string | null | Array<string>;
    @Prop() placeholder!: string;
    @Prop() exceptUsers!: string[];
    @Prop() permissions!: PermissionTypeEnum[];

    @Ref() autocomplete!: Autocomplete;

    protected tenantUserId: string | null = null;

    @Watch('inputValue')
    onInputValueChanged(newValue: string) {
        this.tenantUserId = newValue;
    }

    @Watch('innerValue')
    onInnerValueChanged(newValue: string) {
        this.tenantUserId = newValue;
    }

    mounted() {
        if (this.innerValue) {
            this.tenantUserId = this.innerValue;
        } else if (this.inputValue) {
            this.tenantUserId = this.inputValue;
        }
    }

    get items(): TenantUserModel[] {
        let items = [...(tenantUsersStore.useGetter(CrudGetter.Data) as TenantUserModel[])];
        if (this.exceptUsers) {
            items = items
                .where((x) => !this.exceptUsers.contains(x.id!) || x.id! == this.innerValue || x.id! == this.inputValue)
                .toArray();
        }
        if (this.permissions && this.permissions?.length > 0) {
            items = items
                .where(
                    (x) =>
                        x.userRoles?.any((n) =>
                            n.role!.permissions!.any((j) => this.permissions.contains(j.permissionType!))
                        ) ||
                        x.id! == this.innerValue ||
                        x.id! == this.inputValue
                )
                .toArray();
        }
        if (this.categoryId != null && typeof this.categoryId == 'string') {
            items = items.where((x) => x.categories?.any((c) => c.categoryId == this.categoryId) == true || x.accessAllCategories == true).toArray();
        } else if (this.categoryId && this.categoryId!.length > 0) {
            items = items.where((x) => x.categories?.any((c) => this.categoryId!.includes(c.categoryId!)) == true || x.accessAllCategories == true).toArray();
        }
        return items
            .where((x) => x.isActive == true || x.id! == this.innerValue || x.id! == this.inputValue)
            .toArray()
            .sort((a: TenantUserModel, b: TenantUserModel) => {
                if (a.user!.displayName! < b.user!.displayName!) {
                    return -1;
                }
                if (a.user!.displayName! > b.user!.displayName!) {
                    return 1;
                }
                return 0;
            });
    }

    tenantUserName(e: TenantUserModel): string {
        const baseName = e.user!.displayName!;

        const parts: string[] = [];
        if (this.showDepartment && e.department) {
            parts.push(e.department.name ?? '');
        }

        const locationNames = (e.locations ?? [])
            .map((x) => this.getLocationName(x.locationId))
            .filter((x) => (x ?? '').length > 0)
            .sort((a, b) => a.localeCompare(b));

        if (locationNames.length > 0) {
            parts.push(...locationNames);
        }

        if (parts.length > 0) {
            return `${baseName} (${parts.join(', ')})`;
        }
        return baseName;
    }

    getLocationName(locationId?: string | null): string {
        if (!locationId) return '';
        const all: LocationModel[] = locationsStore.useGetter(CrudGetter.Data) ?? [];
        const found: LocationModel | undefined = (all as any).firstOrDefault
            ? (all as any).firstOrDefault((x: LocationModel) => x.id == locationId)
            : all.find((x) => x.id == locationId);
        return found?.name ?? '';
    }

    onChange(value: string | null) {
        this.$emit('input', value);
        this.$emit('change', value);
    }
}
